import React from 'react';
import PropTypes from 'prop-types';

const CircleXIcon = ({ size = 16, color = '#E0002B' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99999 1.16666C3.9499 1.16666 0.666656 4.4499 0.666656 8.49999C0.666656 12.5501 3.9499 15.8333 7.99999 15.8333C12.0501 15.8333 15.3333 12.5501 15.3333 8.49999C15.3333 4.4499 12.0501 1.16666 7.99999 1.16666ZM10.4714 6.02858C10.7317 6.28894 10.7317 6.71104 10.4714 6.9714L8.94279 8.49999L10.4714 10.0286C10.7317 10.2889 10.7317 10.7111 10.4714 10.9714C10.2111 11.2317 9.78892 11.2317 9.52859 10.9714L7.99999 9.44279L6.4714 10.9714C6.21104 11.2317 5.78894 11.2317 5.52858 10.9714C5.26824 10.7111 5.26824 10.2889 5.52858 10.0286L7.05719 8.49999L5.52858 6.9714C5.26824 6.71104 5.26824 6.28894 5.52858 6.02858C5.78894 5.76824 6.21104 5.76824 6.4714 6.02858L7.99999 7.55719L9.52859 6.02858C9.78892 5.76824 10.2111 5.76824 10.4714 6.02858Z"
      fill={color}
    />
  </svg>
);

CircleXIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default CircleXIcon;
